import { render, staticRenderFns } from "./BaseNavLink.vue?vue&type=template&id=579fa3f8&scoped=true"
import script from "./BaseNavLink.vue?vue&type=script&lang=ts"
export * from "./BaseNavLink.vue?vue&type=script&lang=ts"
import style0 from "./BaseNavLink.vue?vue&type=style&index=0&id=579fa3f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579fa3f8",
  null
  
)

export default component.exports